import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const logApi = createAsyncThunk("log", async () => {
  const response = await axiosInstance.get("/log");
  return response.data;
});

const logSlice = createSlice({
  name: "log",
  initialState: {
    log: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(logApi.fulfilled, (state, action) => {
        state.log = action.payload;
        state.loading = false;
      })
      .addCase(logApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default logSlice.reducer;
